export default __webpack_public_path__ + "static/media/1213 knife block B top.e925770b.png";